<template>
  <div class="home h-95">
    <a-row type="flex" class="h-15 header-row" :class="{ 'dark-theme-element': darkTheme }">
      <a-col :span="24">
        <Header/>
      </a-col>
    </a-row>
    <a-row type="flex" class="h-85">
      <a-col class="h-100 scroll" :class="[toggled ? 'minimized-sidebar-column': 'sidebar-column', {'dark-theme-element': darkTheme}]">
        <Sidebar/>
      </a-col>
      <a-col class="h-100 scroll" :span="21" :class="toggled ? 'minimized-grid-column': 'grid-column'">
        <router-view/>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import Header from '@/components/Header.vue'
import Sidebar from '@/components/sidebar/Sidebar.vue'

export default {
  name: 'layout',
  components: {
    Header,
    Sidebar
  },
  computed: {
    ...mapState({
      toggled: state => state.sidebar.toggled,
      darkTheme: state => state.darkTheme
    })
  }
}
</script>

<style scoped lang="scss">
.header-row{
  min-height: 120px;
}
.minimized-sidebar-column{
  transition: all 0.2s ease-out;
  width: 80px;
  border-right: 1px solid lightgray;
}
.minimized-grid-column{
  transition: all 0.2s ease-out;
  width: calc(100% - 80px);
}
// Sidebar taille fixe
.sidebar-column{
  transition: all 0.2s ease-in;
  width: 180px;
  flex: none;
  border-right: 1px solid lightgray;
}
.grid-column{
  transition: all 0.2s ease-in;
  width: calc(100% - 180px);
}
@media screen and (max-width: 767px){
  //Sidebar taille fixe minimisée
  .sidebar-column{
    width: 80px;
  }
  .grid-column{
    width: calc(100% - 80px);
  }
}
</style>
